import Container from '@anm/components/Container';
import TitleBlock, { TitleDescription } from '@anm/components/TitleBlock';
import Image from '@anm/components/image/Image';
import getFromCdn from '@anm/helpers/getFromCdn';
import { centeredInFullHeight, device } from '@anm/styles/helpers';
import styled from 'styled-components';
export var FakeHeader = styled.div.withConfig({
  componentId: "sc-1oic9ym-0"
})(["height:74px;box-shadow:0 2px 10px rgba(1,83,130,0.1);padding:0 20px;display:flex;align-items:center;@media ", "{padding:0 40px;}"], device.laptop);
export var LogoWrapper = styled(Image).withConfig({
  componentId: "sc-1oic9ym-1"
})(["width:140px;height:30px;display:inline-block;"]);
export var CTABlock = styled.div.withConfig({
  componentId: "sc-1oic9ym-2"
})(["padding:20px 50% 20px 20px;border-radius:20px;display:flex;flex-direction:column;justify-content:space-between;text-align:left;width:100%;background-image:url(", ");background-color:#f29397;background-position:right 20% bottom;background-repeat:no-repeat;background-size:auto 95%;@media ", "{padding:40px 40% 20px 50px;}"], getFromCdn('images/video-landings/laptopgirl.png'), device.laptop);
export var CTATitleBlock = styled(TitleBlock).withConfig({
  componentId: "sc-1oic9ym-3"
})(["h1,h2,h3,h4,h5{margin-bottom:70px;}a{color:#292a2b;&:hover{text-decoration:none;}}"]);
var ErrorWrapper = styled(Container).withConfig({
  componentId: "sc-1oic9ym-4"
})(["", ";flex-direction:column;justify-content:space-around;font-family:'Inter',sans-serif;"], centeredInFullHeight());
export var ErrorTitleBlockWrapper = styled.div.withConfig({
  componentId: "sc-1oic9ym-5"
})(["display:flex;flex-direction:column;"]);
export var ErrorTitleBlockIcon = styled(Image).withConfig({
  componentId: "sc-1oic9ym-6"
})(["width:30px;margin-right:10px;"]);
export var ErrorTitleIconWrapper = styled.div.withConfig({
  componentId: "sc-1oic9ym-7"
})(["display:flex;align-items:baseline;"]);
export var ErrorTitleBlock = styled(TitleBlock).withConfig({
  componentId: "sc-1oic9ym-8"
})(["text-align:center;h1,h2,h3,h4,h5{font-size:30px;font-weight:700;line-height:36px;margin:0 0 18px;}", "{margin:0 auto 20px;font-style:normal;font-weight:normal;font-size:17px;line-height:28px;}a{color:var(--blue_100);text-decoration:none;&:hover{text-decoration:underline;}}"], TitleDescription);
export default ErrorWrapper;